import React, { useEffect } from 'react';
import produce from 'immer';
import format from 'date-fns/format';

import {
  Table,
  TableRow,
  TableCell,
  Pagination,
  TableHeader,
} from '@unimed-fesp/components';

import { TipoPerfilUsuarioEnum } from '../../../enums';

import CustomScrollbars from '../../molecules/CustomScrollBars';

const TableHeaderComponent = () => {
  return (
    <TableRow>
      <TableHeader>Responsável</TableHeader>
      <TableHeader>Perfil</TableHeader>
      <TableHeader>Ação</TableHeader>
      <TableHeader>E-mail</TableHeader>
      <TableHeader>Data</TableHeader>
    </TableRow>
  );
};

const HistoricoMovimentacoes = ({
  usuarioHistoricoMovimentacao,
  pageData,
  sizeData,
  setPaginationParams,
  paginationParams,
  handlePageChangeKeyDown,
  handleChangePage,
}) => {
  useEffect(() => {
    const newPaginationParams = produce(paginationParams, (draft) => {
      draft.pageNumber = pageData.pageNumber;
      draft.pageSize = pageData.pageSize;
      draft.totalPages = Math.ceil(sizeData / pageData.pageSize);

      return draft;
    });

    setPaginationParams(newPaginationParams);
    // setNewPageAtual(pageData.pageNumber);
    // setPageSize(pageData.pageSize);
  }, []);

  return (
    <>
      <CustomScrollbars
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        autoHeight
        autoHeightMin={0}
        autoHeightMax={420}
        thumbMinSize={30}
        universal
      >
        <Table head={<TableHeaderComponent />}>
          {usuarioHistoricoMovimentacao.map((historico, index) => (
            <TableRow key={historico.idUsuarioHistorico}>
              <TableCell>
                {historico.nomeResponsavel ? historico.nomeResponsavel : '-'}
              </TableCell>
              <TableCell>
                {historico.tipoPerfil
                  ? TipoPerfilUsuarioEnum.returnNameFormattedForName[
                      historico.tipoPerfil
                    ]
                  : '-'}
              </TableCell>
              <TableCell>{historico.dcAcao ? historico.dcAcao : '-'}</TableCell>
              <TableCell>
                {historico.emailResponsavel ? historico.emailResponsavel : '-'}
              </TableCell>
              <TableCell>
                {historico.dtInclusaoHistorico
                  ? format(
                      new Date(historico.dtInclusaoHistorico),
                      'dd/MM/yyyy HH:mm',
                      {
                        timeZone: 'America/Sao_Paulo',
                      }
                    )
                  : '-'}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </CustomScrollbars>
      {pageData.total > 10 && (
        <Pagination
          total={pageData.total}
          paginationParams={paginationParams}
          callbackChangePage={handleChangePage}
          setPaginationParams={setPaginationParams}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
        />
      )}
    </>
  );
};

export default HistoricoMovimentacoes;
